module.exports = __webpack_public_path__ + "img/logo-square-white-on-transparent.98620c85.svg";